import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { categoryApi } from '../services/api';

function Home() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const categoriesData = await categoryApi.getCategoriesWithCount();
      setCategories(categoriesData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const zhishikuCards = [
    
     {
      id: 'bazi_books',
      title: '八字书籍',
      desc: '渊海子平、滴天髓等命理典籍',
      route: '/category/bazi',
      color: 'bg-orange-50 border-orange-100',
    },
    {
      id: 'qimen_books',
      title: '奇门书籍',
      desc: '奇门遁甲古籍与现代著作',
      route: '/category/qimen',
      color: 'bg-blue-50 border-blue-100',
    },
    {
      id: 'liuyao_books',
      title: '六爻书籍',
      desc: '增删卜易、卜筮正宗等经典',
      route: '/category/liuyao',
      color: 'bg-teal-50 border-teal-100',
    },
    {
       id: 'zhouyu',
       title: '符箓',
       desc: '道家符咒与诵持方法',
       route: '/fulu',
       color: 'bg-purple-50 border-purple-100',
    },
    {
      id: 'fulu',
      title: '符咒',
      desc: '道家符箓绘制与应用解析',
      route: '/fuzou',
      color: 'bg-indigo-50 border-indigo-100',
    },
    {
      id: 'video_courses',
      title: '视频课程',
      desc: '易学名师视频讲解与实战',
      route: '/courses',
      color: 'bg-red-50 border-red-100',
    },
  ];
    const getCardRingColor = (cardId) => {
      const map = {
        bazi_books: 'ring-orange-200/80',
        qimen_books: 'ring-blue-200/80',
        liuyao_books: 'ring-teal-200/80',
        zhouyu: 'ring-purple-200/80',
        fulu: 'ring-indigo-200/80',
        video_courses: 'ring-rose-200/80',
      };
      return map[cardId] || 'ring-slate-200/80';
    };

  const getCategoryRoute = (route) => {
    if (route === '/category/bazi') {
      const category = categories.find((item) => item.name === '八字命理');
      return category ? `/category/${category.id}` : '/books';
    }
    if (route === '/category/qimen') {
      const category = categories.find((item) => item.name === '奇门遁甲');
      return category ? `/category/${category.id}` : '/books';
    }
    if (route === '/category/liuyao') {
      const category = categories.find((item) => item.name === '六爻预测');
      return category ? `/category/${category.id}` : '/books';
    }
    return route;
  };

  const getCategoryBookCount = (route) => {
    if (route === '/category/bazi') {
      const category = categories.find((item) => item.name === '八字命理');
      return category?.book_count ?? 0;
    }
    if (route === '/category/qimen') {
      const category = categories.find((item) => item.name === '奇门遁甲');
      return category?.book_count ?? 0;
    }
    if (route === '/category/liuyao') {
      const category = categories.find((item) => item.name === '六爻预测');
      return category?.book_count ?? 0;
    }
    return null;
  };

  if (loading) {
    return (
      <div className="flex min-h-[65vh] items-center justify-center bg-slate-50">
        <div className="rounded-2xl border border-slate-200 bg-white px-8 py-6 text-slate-700 shadow-sm">
          正在加载首页内容...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-rose-200 bg-rose-50 p-6">
        <p className="text-rose-700">加载失败: {error}</p>
        <button 
          onClick={loadData}
          className="mt-4 rounded-lg bg-rose-600 px-4 py-2 text-white transition hover:bg-rose-700"
        >
          重试
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <header className="relative overflow-hidden rounded-b-[2rem] bg-gradient-to-br from-emerald-700 via-teal-700 to-cyan-800 px-6 pb-16 pt-16 text-white shadow-lg">
        <div className="pointer-events-none absolute -left-16 -top-16 h-52 w-52 rounded-full bg-white/10 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-16 -right-16 h-64 w-64 rounded-full bg-cyan-200/10 blur-2xl" />

        <div className="relative mx-auto max-w-6xl">
          <div className="mx-auto max-w-3xl text-center">
            <p className="inline-flex rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs text-emerald-50">
              圆運 · 易学数字知识平台
            </p>
            <h1 className="mt-4 text-3xl font-bold tracking-tight md:text-5xl">圆運知识库</h1>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-emerald-100 md:text-lg">
              汇集符箓、咒语、古籍与视频课程，打造体系化易学知识入口。
            </p>
          </div>
        </div>
      </header>

      <section className="mx-auto -mt-10 max-w-6xl px-4 pb-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6">
          {zhishikuCards.map((card) => (
            <Link
              key={card.id}
              to={getCategoryRoute(card.route)}
              className="group"
            >
              <article
                className={`relative flex min-h-[150px] cursor-pointer flex-col justify-between overflow-hidden rounded-2xl border ${card.color} bg-white p-5 text-center shadow-sm ring-1 ${getCardRingColor(card.id)} transition-all duration-300 hover:-translate-y-1 hover:shadow-lg`}
              >
                {getCategoryBookCount(card.route) !== null && (
                  <span className="absolute right-3 top-3 rounded-full bg-orange-100 px-2 py-1 text-xs font-semibold text-orange-700">
                    {getCategoryBookCount(card.route)} 本
                  </span>
                )}
                <h3 className="text-lg font-bold text-slate-900">{card.title}</h3>
                <p className="mt-2 hidden text-sm leading-relaxed text-slate-500 sm:block">
                  {card.desc}
                </p>
                <div className="mt-3 text-xs font-medium text-slate-400 group-hover:text-slate-600">点击进入</div>
              </article>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
